// extracted by mini-css-extract-plugin
export default {"gradient":"athlete_gradient__Dl3m1"};